export const HOMEPAGE_TRANSITION_NAME = "homepage";
export const SWEEP_LINE_TRANSITION_NAME = "homepage-sweep-line";

/** Set on <html> only while a switch animates; it is what names the homepage area. */
export const SWITCHING_ATTRIBUTE = "data-homepage-switching";

export const SWEEP_DURATION_MS = 700;
export const SWEEP_EASING = "cubic-bezier(.6,0,.2,1)";
export const SWEEP_LINE_FADE_MS = 160;

/**
 * How long a switch may hold the old homepage on screen (frozen by the view
 * transition) while the other one's code arrives, when nothing preloaded it.
 * Kept short: a frozen page reads as broken, a loading one doesn't.
 */
export const MAX_SWITCH_WAIT_MS = 400;

/** Head start the visible homepage's own requests get before the other one starts loading. */
export const PRELOAD_DELAY_MS = 2000;

/** requestIdleCallback timeout, so a busy page still preloads eventually. */
export const PRELOAD_IDLE_TIMEOUT_MS = 3000;

/**
 * How long /home waits for the flags (sandbox_new_homepage) before rendering
 * with what they read then (off). Statsig usually answers in a few hundred ms;
 * its own network timeout is 10s, far too long to hold the landing page.
 */
export const MAX_FLAG_WAIT_MS = 1500;
